import React from 'react'
import { Link } from 'gatsby'
import './button.scss'

export default function Button(props) {
  const { className, children, link, styles, ...buttonProps } = props;
  return (
    <>
      {props.link ? (
        <Link
          className={`btn ${props.className ? props.className : ``} ${
            props.styles ? props.styles : `primary`
          }`}
          to={link}
          {...buttonProps}
        >
          {props.text}
        </Link>
      ) : (
        <button
          className={`btn ${className ? className : ``} ${
            styles ? styles : `primary`
          }`}
          {...buttonProps}
        >
          {props.text ? props.text : props.children}
        </button>
      )}
    </>
  );
}
